import { createFileRoute } from '@tanstack/react-router'
import PropertiesSettingsPage from '@/pages/settings/properties'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/properties'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <PropertiesSettingsPage />
}